import { CoreApi } from '/src/helpers/CoreApi'
import Layout from '/src/components/@common.blocks/Layout'
import CollectionsList from '/src/components/@sections/CollectionsList'

const CollectionsPage = ({ collections }) => {
  return (
    <Layout
      title='NFT collections'
      description='CryptoPunks, Bored Ape Yacht Club, Otherdeed for Otherside, Azuki, Moonbirds & more'
      footer={false}
    >
      <CollectionsList data={collections} />
    </Layout>
  )
}

export async function getServerSideProps(ctx) {
  const collections = await CoreApi.getCollections({
    sort: 'volumeD',
    size: 20,
  })
  return {
    props: { collections },
  }
}

export default CollectionsPage
